<!-- Generated by AI start - Cursor - 2025-08-22 -->
<template>
  <div class="subscription-success-page">
    <div class="success-container">
      <!-- 成功图标 -->
      <div class="success-icon">
        <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle
            cx="32"
            cy="32"
            r="30"
            fill="#108EE9"
            stroke="#108EE9"
            stroke-width="2"
          />
          <path
            d="M20 32l8 8 16-16"
            stroke="white"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>

      <!-- 成功标题 -->
      <h1 class="success-title">Operation Successful!</h1>
      <!-- 完成按钮 -->
      <!-- <button class="complete-button" @click="handleComplete">
        ok
      </button> -->
      <!-- 换成a标签跳转 -->
      <a
        class="complete-button"
        :href="returnUrl"
        v-if="
          returnUrl &&
            returnUrl !== '' &&
            returnUrl !== 'undefined' &&
            returnUrl !== null
        "
      >
        ok
      </a>
    </div>
  </div>
</template>

<script>
import utils from "@/utils/index";
export default {
  name: "subSuccess",
  data() {
    return {
      returnUrl: ""
    };
  },
  mounted() {
    // 从URL参数中获取returnUrl
    this.getReturnUrl();
  },
  methods: {
    getReturnUrl() {
      this.returnUrl = decodeURIComponent(
        utils.getUrlParmas(window.location.href).returnUrl
      );
    },
    handleComplete() {
      // 跳转到returnUrl
      if (this.returnUrl) {
        window.location.href = this.returnUrl;
      }
      // 在某些环境下可能需要关闭当前窗口
      try {
        window.close();
      } catch (e) {
        // 如果无法关闭窗口，静默处理
        console.log("无法关闭窗口，可能在非弹窗环境中");
      }
    }
  }
};
</script>

<style scoped>
.subscription-success-page {
  min-height: 100vh;
  display: flex;
  /* align-items: center; */
  justify-content: center;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
    sans-serif;
}

.success-container {
  background: white;
  border-radius: 20px;
  padding: 40px 30px;
  text-align: center;
  max-width: 360px;
  width: 100%;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  animation: slideUp 0.5s ease-out;
  padding-top: 100px;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.success-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 30px;
  border-radius: 50%;
  /* background: #ffaa0a; */
  display: flex;
  align-items: center;
  justify-content: center;
  animation: scaleIn 0.6s ease-out 0.2s both;
}

@keyframes scaleIn {
  from {
    opacity: 0;
    transform: scale(0.3);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.success-icon svg {
  width: 60px;
  height: 60px;
}

.success-title {
  font-size: 28px;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 20px;
  animation: fadeIn 0.6s ease-out 0.4s both;
}

.success-description {
  font-size: 16px;
  color: #6b7280;
  line-height: 1.6;
  margin: 0 0 40px;
  animation: fadeIn 0.6s ease-out 0.6s both;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.complete-button {
  display: block;
  background: #108ee9;
  color: white;
  border: none;
  border-radius: 44px;
  font-size: 18px;
  font-weight: 400;
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  animation: fadeIn 0.6s ease-out 0.8s both;
  margin-top: 20px;
}

.complete-button:hover {
  background: rgba(16, 142, 233, 0.9);
  transform: translateY(-1px);
}

.complete-button:active {
  background: rgba(16, 142, 233, 0.8);
  transform: translateY(0);
}

/* 移动端适配 */
@media (max-width: 480px) {
  .subscription-success-page {
    padding: 15px;
  }

  .success-icon {
    width: 70px;
    height: 70px;
    margin-bottom: 25px;
  }

  .success-title {
    font-size: 24px;
    margin-bottom: 15px;
  }

  .success-description {
    font-size: 15px;
    margin-bottom: 35px;
  }

  .complete-button {
    line-height: 40px;
    font-size: 16px;
    height: 40px;
    border-radius: 20px;
  }
}

/* 超小屏幕适配 */
@media (max-width: 360px) {
  .success-title {
    font-size: 22px;
  }

  .success-description {
    font-size: 14px;
  }
}
</style>
<!-- Generated by AI end -->
